import React from "react";
import LazyLoad from "react-lazyload";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

const ProgramCard = ({ program }) => {
  const navigate = useNavigate();
  const formattedDate = format(new Date(program.date), "MMMM d, yyyy");

  const handleClick = () => {
    navigate("/programs/details/", { state: program });
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        borderRadius: "20px",
        backgroundColor: "#1A2E55",
        overflow: "hidden",
        boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.4s ease, box-shadow 0.4s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 16px 50px rgba(0, 123, 255, 0.3)",
        },
      }}
    >
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <LazyLoad height={240} offset={100} once>
          <CardMedia
            component="img"
            image={program.image}
            alt={program.title}
            sx={{
              height: 240,
              width: "100%",
              objectFit: "cover",
              transition: "all 0.4s ease",
              "&:hover": {
                transform: "scale(1.05)",
                filter: "brightness(1.1)",
              },
            }}
          />
        </LazyLoad>
      </Box>

      <CardContent
        sx={{
          padding: "20px 24px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flexGrow: 1,
        }}
      >
        <Box sx={{ marginBottom: "16px" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: "1.5rem",
              color: "#FFFFFF",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginBottom: "10px",
            }}
          >
            {program.title}
          </Typography>

          <Typography
            variant="subtitle2"
            sx={{
              color: "#A9C9EA",
              fontSize: "0.875rem",
            }}
          >
            {formattedDate} &bull; {program.location} &bull;{" "}
            {program.program_type_display}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            color: "#D1D5DB",
            lineHeight: 1.7,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginBottom: "16px",
          }}
        >
          {program.description}
        </Typography>

        <Button
          variant="outlined"
          onClick={handleClick}
          sx={{
            alignSelf: "center",
            padding: "10px 30px",
            color: "#10a7e0",
            borderColor: "#10a7e0",
            borderRadius: "30px",
            fontSize: "0.875rem",
            fontWeight: 600,
            textTransform: "uppercase",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              backgroundColor: "#10a7e0",
              color: "#FFFFFF",
              boxShadow: "0 6px 20px rgba(0, 166, 255, 0.4)",
              transform: "translateY(-3px)",
            },
          }}
        >
          View Details
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProgramCard;
